/* tslint:disable */
/* eslint-disable */
export enum LicenceType {
  AllInOne = 'AllInOne',
  Centralised = 'Centralised',
  Decentralised = 'Decentralised',
  OnCloud = 'OnCloud'
}
